const dotColorMap = Object.freeze({
  positive: 'green',
  negative: 'red',
  caution: 'orange',
  informative: 'accent',
  neutral: 'grey',
});

export const getDotColor = dot => {
  if (dot && dot.color) {
    return dotColorMap[dot.color.toLowerCase()] || dotColorMap.neutral;
  }
  return null;
};
